var _rect, _path, _path2, _path3, _path4, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#FFF5ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2936 19.0511H21.6797V30.9487H28.2936V19.0511Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1006 25C22.0996 23.8541 22.3589 22.7231 22.8591 21.6925C23.3593 20.6618 24.0872 19.7586 24.9876 19.0512C23.8725 18.1738 22.5334 17.6282 21.1232 17.4767C19.713 17.3252 18.2886 17.5739 17.013 18.1944C15.7373 18.8149 14.6618 19.7822 13.9093 20.9856C13.1568 22.1891 12.7578 23.5802 12.7578 25C12.7578 26.4197 13.1568 27.8108 13.9093 29.0143C14.6618 30.2178 15.7373 31.185 17.013 31.8055C18.2886 32.426 19.713 32.6747 21.1232 32.5232C22.5334 32.3717 23.8725 31.8261 24.9876 30.9487C24.0872 30.2413 23.3593 29.3381 22.8591 28.3075C22.359 27.2768 22.0996 26.1458 22.1006 25Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2177 25C37.2177 26.4197 36.8187 27.8108 36.0663 29.0143C35.3139 30.2177 34.2384 31.185 32.9628 31.8055C31.6871 32.426 30.2628 32.6747 28.8526 32.5232C27.4425 32.3717 26.1033 31.8261 24.9883 30.9487C25.8879 30.2406 26.6152 29.3372 27.1153 28.3068C27.6154 27.2763 27.8752 26.1456 27.8752 25C27.8752 23.8543 27.6154 22.7236 27.1153 21.6932C26.6152 20.6627 25.8879 19.7593 24.9883 19.0512C26.1033 18.1738 27.4425 17.6282 28.8526 17.4767C30.2628 17.3252 31.6871 17.5739 32.9628 18.1944C34.2384 18.8149 35.3139 19.7822 36.0663 20.9857C36.8187 22.1891 37.2177 23.5802 37.2177 25Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4916 29.6886V29.445H36.5897V29.3954H36.3398V29.445H36.438V29.6886H36.4916ZM36.9767 29.6886V29.3949H36.9001L36.812 29.5969L36.7239 29.3949H36.6473V29.6886H36.7014V29.4671L36.784 29.658H36.8401L36.9227 29.4666V29.6886H36.9767Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    stroke: "#FECBAA",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.a8df928ebe56810c61a414387d33b766.svg";
export { ForwardRef as ReactComponent };